export const LOGO_URL = "https://customer-assets-agu9un31.emergentagent.net/job_nutrifit-client-1/artifacts/his27qrf_IMG_0495.webp";

export function Logo({ className = "", showText = true }) {
  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="app-logo">
      <img src={LOGO_URL} alt="Solano Essence" className="h-9 w-auto object-contain" />
    </div>
  );
}

export function LogoMark({ size = 32 }) {
  return (
    <img
      src={LOGO_URL}
      alt="Solano Essence"
      style={{ height: size }}
      className="w-auto object-contain"
      data-testid="app-logo-mark"
    />
  );
}
